import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Container from './components/Container';
import Home from './screens/home/Home';
import Video from './screens/video/Video';
import Adds from './screens/adds/Adds';

export default function (p){
  return (
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route exact path="/video/:id" component={Video}/>
      <Route exact path="/atimidia" render={()=><Adds firebase={p.firebase}/>}/>
    </Switch>
  );
}
